// import { useState, useRef, useEffect } from "react";
// import "../../Dropdown.css";
// export default function Dropdown({ field, newOrder, setNewOrder, items, placeholder }) {
//   const [open, setOpen] = useState(false);
//   const [search, setSearch] = useState("");

//   return (
//     <div className="form-group">
//       <div className="dropdown-select" onClick={() => setOpen(!open)}>
//         {newOrder[field]
//           ? items.find(i => i.id === newOrder[field])?.name
//           : placeholder}
//       </div>

//       {open && (
//         <div className="dropdown-menu">
//           <input
//             type="text"
//             placeholder={`جستجوی ${placeholder}...`}
//             className="dropdown-menu-search"
//             value={search}
//             onChange={e => setSearch(e.target.value)}
//           />
//           <div className="dropdown-menu-inner">
//             {items.filter(i => i.name.includes(search)).map(i => (
//               <div
//                 key={i.id}
//                 className={`dropdown-menu-item ${newOrder[field] === i.id ? "is-select" : ""}`}
//                 onClick={() => {
//                   setNewOrder({ ...newOrder, [field]: i.id });
//                   setOpen(false);
//                   setSearch("");
//                 }}
//               >
//                 {i.name}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }





import { useState, useRef, useEffect } from "react";
import "./Dropdown.css";

export default function Dropdown({
  type = "single",          // "single" | "provinceCity"
  value,                    // برای single: id ، برای provinceCity: {province, city}
  onChange,                 // برای single: id برمیگردونه ، برای provinceCity: {province, city}
  items = [],               // آرایه‌ی آبجکت {id,name} برای حالت single
  placeholder = "",         // متن پیشفرضچ
  itemType = "",            // ← این خط اضافه شد

}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  // استان/شهر استیت‌های داخلی
  const [selectedProvince, setSelectedProvince] = useState(
    type === "provinceCity" ? value?.province || "" : ""
  );
  const [selectedCity, setSelectedCity] = useState(
    type === "provinceCity" ? value?.city || "" : ""
  );
  const [provinceOpen, setProvinceOpen] = useState(false);
  const [cityOpen, setCityOpen] = useState(false);
  const [provinceSearch, setProvinceSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");

  // بستن منو در کلیک بیرون
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setProvinceOpen(false);
        setCityOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // آپدیت بیرونی در حالت provinceCity
  useEffect(() => {
    if (type === "provinceCity") {
      onChange({ province: selectedProvince, city: selectedCity });
    }
  }, [selectedProvince, selectedCity]);

  if (type === "single") {
    // -------- حالت تک سطحی (visitor / seller) --------
    const filtered = items.filter((i) => i.name.includes(search));

    return (
      <div className="form-group" ref={ref}>
        <div className="dropdown-select" onClick={() => setOpen(!open)}>
{value 
    ? (() => {
        const i = items.find((i) => i.id === value);
        if (!i) return placeholder;
        return itemType === "product"
          ? `${i.name} ${i.category || ""} ${i.brand || ""} - ${Number(i.price).toLocaleString("fa-IR")} تومان`
          : itemType === "seller"
            ? `${i.name} ${i.surname || ""} - ${i.shop_name || ""}`
            : itemType === "marketer"
              ? `${i.name} ${i.surname || ""}`
              : i.name;
      })()
    : placeholder}        </div>
        {open && (
          <div className="dropdown-menu">
            <input
              type="text"
              placeholder={`جستجو...`}
              className="dropdown-menu-search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="dropdown-menu-inner">
              {filtered.map((i) => (
                <div
                  key={i.id}
                  className={`dropdown-menu-item ${value === i.id ? "is-select" : ""}`}
                  onClick={() => {
                    onChange(i.id);
                    setOpen(false);
                    setSearch("");
                  }}
                >
                  {/* {itemType === "seller" 
      ? `${i.name} ${i.surname} - ${i.shop_name}`
      : `${i.name} ${i.surname}`}
       */}{itemType === "product"
                    ? `${i.name} ${i.category || ""} ${i.brand || ""} - ${Number(i.price).toLocaleString("fa-IR")} تومان`
                    : itemType === "seller"
                      ? `${i.name} ${i.surname || ""} - ${i.shop_name || ""}`
                      : itemType === "marketer"
                        ? `${i.name} ${i.surname || ""}`
                        : i.name}


                </div>
              ))}

            </div>
          </div>
        )}
      </div>
    );
  }

  // -------- حالت دو سطحی استان / شهر --------
  const filteredProvinces = provinces.filter((p) =>
    p.name.includes(provinceSearch)
  );
  const filteredCities = selectedProvince
    ? provinces.find((p) => p.name === selectedProvince)?.cities.filter((c) =>
      c.includes(citySearch)
    ) || []
    : [];

  return (
    <div className="wrapper-column" ref={ref}>
      {/* استان */}
      <div className="form-group">
        <div
          className="dropdown-select"
          onClick={() => setProvinceOpen(!provinceOpen)}
        >
          {selectedProvince || "انتخاب استان"}
        </div>
        {provinceOpen && (
          <div className="dropdown-menu">
            <input
              type="text"
              placeholder="جستجوی استان..."
              className="dropdown-menu-search"
              value={provinceSearch}
              onChange={(e) => setProvinceSearch(e.target.value)}
            />
            <div className="dropdown-menu-inner">
              {filteredProvinces.map((p) => (
                <div
                  key={p.name}
                  className={`dropdown-menu-item ${selectedProvince === p.name ? "is-select" : ""}`}
                  onClick={() => {
                    setSelectedProvince(p.name);
                    setSelectedCity("");
                    setProvinceOpen(false);
                    setProvinceSearch("");
                  }}
                >
                  {p.name}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* شهر */}
      <div className="form-group" style={{ marginTop: "1rem" }}>
        <div
          className="dropdown-select"
          onClick={() => selectedProvince && setCityOpen(!cityOpen)}
        >
          {selectedCity || "انتخاب شهر"}
        </div>
        {cityOpen && (
          <div className="dropdown-menu">
            <input
              type="text"
              placeholder="جستجوی شهر..."
              className="dropdown-menu-search"
              value={citySearch}
              onChange={(e) => setCitySearch(e.target.value)}
            />
            <div className="dropdown-menu-inner">
              {filteredCities.map((city) => (
                <div
                  key={city}
                  className={`dropdown-menu-item ${selectedCity === city ? "is-select" : ""}`}
                  onClick={() => {
                    setSelectedCity(city);
                    setCityOpen(false);
                    setCitySearch("");
                  }}
                >
                  {city}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// provinces آرایه‌ی استان‌ها و شهرها رو از قبل ایمپورت یا تعریف کن

const provinces = [
  { "name": "آذربایجان شرقی", "cities": ["تبریز", "مراغه", "مرند", "اهر", "آذرشهر", "اسکو", "بستان‌آباد", "جلفا", "خوی", "هریس"] },
  { "name": "آذربایجان غربی", "cities": ["ارومیه", "خوی", "ماکو", "مهاباد", "بوکان", "سلماس", "پلدشت", "چالدران", "شاهین‌دژ", "نقده"] },
  { "name": "اردبیل", "cities": ["اردبیل", "مشگین‌شهر", "نیر", "خلخال", "بیله‌سوار", "پارس‌آباد", "گرمی", "نمین", "عنبران", "هیر"] },
  { "name": "اصفهان", "cities": ["اصفهان", "کاشان", "نجف‌آباد", "خمینی‌شهر", "شاهین‌شهر", "فریدن", "فریدون‌شهر", "دولت‌آباد", "گلپایگان", "آران و بیدگل"] },
  { "name": "البرز", "cities": ["کرج", "ساوجبلاغ", "نظرآباد", "هشتگرد", "محمدشهر", "فردیس", "کمال‌شهر", "محمودآباد"] },
  { "name": "ایلام", "cities": ["ایلام", "دهلران", "مهران", "آبدانان", "دره‌شهر", "چرداول", "موسیان", "بدره"] },
  { "name": "بوشهر", "cities": ["بوشهر", "دشتستان", "گناوه", "دیر", "کنگان", "جم", "تنگستان", "برازجان"] },
  { "name": "تهران", "cities": ["تهران", "ری", "شهریار", "اسلامشهر", "پردیس", "دماوند", "فیروزکوه", "پاکدشت", "رباط‌کریم", "بومهن"] },
  { "name": "چهارمحال و بختیاری", "cities": ["شهرکرد", "لردگان", "بروجن", "فارسان", "کیار", "بن", "اردل", "کوهرنگ"] },
  { "name": "خراسان جنوبی", "cities": ["بیرجند", "قائنات", "نهبندان", "سرایان", "فردوس", "سربیشه", "طبس", "درمیان", "خوسف"] },
  { "name": "خراسان رضوی", "cities": ["مشهد", "سبزوار", "نیشابور", "تربت‌حیدریه", "کاشمر", "گناباد", "تربت‌جام", "خواف", "چناران", "فریمان"] },
  { "name": "خراسان شمالی", "cities": ["بجنورد", "شیروان", "اسفراین", "آشخانه", "جاجرم", "گرمه", "فاروج", "مانه و سملقان"] },
  { "name": "خوزستان", "cities": ["اهواز", "دزفول", "آبادان", "خرمشهر", "ماهشهر", "بهبهان", "اندیمشک", "شوش", "اندیکا", "مسجدسلیمان"] },
  { "name": "زنجان", "cities": ["زنجان", "خدابنده", "ابهر", "خرمدره", "طارم", "ایجرود", "ماهنشان", "سلطانیه"] },
  { "name": "سمنان", "cities": ["سمنان", "شاهرود", "دامغان", "مهدی‌شهر", "گرمسار", "میامی", "سرخه", "آرادان"] },
  { "name": "سیستان و بلوچستان", "cities": ["زاهدان", "زابل", "خاش", "چابهار", "ایرانشهر", "نیک‌شهر", "سراوان", "دلگان", "فنوج", "سرباز"] },
  { "name": "فارس", "cities": ["شیراز", "مرودشت", "کازرون", "جهرم", "فسا", "داراب", "استهبان", "لارستان", "نی‌ریز", "بوانات"] },
  { "name": "قزوین", "cities": ["قزوین", "تاکستان", "آبگرم", "بوئین‌زهرا", "الوند", "شال", "محمودآباد"] },
  { "name": "قم", "cities": ["قم"] },
  { "name": "کردستان", "cities": ["سنندج", "قروه", "بیجار", "کامیاران", "دیواندره", "بانه", "مریوان", "سقز", "دهگلان"] },
  { "name": "کرمان", "cities": ["کرمان", "رفسنجان", "سیرجان", "جیرفت", "بم", "زرند", "کوه‌بن", "انار", "راور", "بافت"] },
  { "name": "کرمانشاه", "cities": ["کرمانشاه", "سنقر", "صحنه", "هرسین", "کنگاور", "اسلام‌آباد غرب", "قصرشیرین", "گیلانغرب", "ثلاث‌باباجانی", "دالاهو"] },
  { "name": "کهگیلویه و بویراحمد", "cities": ["یاسوج", "گچساران", "دوگنبدان", "دهدشت", "باشت", "سی‌سخت", "لنده", "چیتاب"] },
  { "name": "گلستان", "cities": ["گرگان", "بندرترکمن", "آزادشهر", "کردکوی", "گنبدکاووس", "رامیان", "مینودشت", "علی‌آباد کتول", "گالیکش", "آق‌قلا"] },
  { "name": "گیلان", "cities": ["رشت", "انزلی", "آستارا", "صومعه‌سرا", "لنگرود", "رودسر", "تالش", "فومن", "ماسال", "رودبار"] },
  { "name": "لرستان", "cities": ["خرم‌آباد", "بروجرد", "دورود", "الیگودرز", "پلدختر", "ازنا", "کوهدشت", "چگنی", "سلسله", "دلفان"] },
  { "name": "مازندران", "cities": ["ساری", "بابل", "آمل", "نوشهر", "قائم‌شهر", "بهشهر", "بابلسر", "نکا", "رامسر", "تنکابن", "چالوس"] },
  { "name": "مرکزی", "cities": ["اراک", "ساوه", "خمین", "محلات", "کمیجان", "دلیجان", "تفرش", "آشتیان", "خنداب", "زرندیه"] },
  { "name": "هرمزگان", "cities": ["بندرعباس", "بندرلنگه", "قشم", "بندر خمیر", "میناب", "رودان", "پارسیان", "بستک", "حاجی‌آباد", "جاسک"] },
  { "name": "همدان", "cities": ["همدان", "ملایر", "نهاوند", "تویسرکان", "اسدآباد", "کبودرآهنگ", "فامنین", "بهار", "رزن", "قهاوند"] },
  { "name": "یزد", "cities": ["یزد", "میبد", "اردکان", "بافق", "تفت", "اشکذر", "خاتم", "بهاباد", "مهرجان", "هرات"] }
];
